import React, { useCallback, useMemo } from 'react';
import { Button, Stack, useTheme } from '@mui/material';
import { Add } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { openDialog } from '@/features/dialog/dialogSlice';
import { useFeatureFlagContext } from '@/context/featureFlagContext';

export const useTopNavCreateActions = () => {
	const dispatch = useDispatch();

	const { getFeatureFlags } = useFeatureFlagContext();
	const showEmail = Boolean(getFeatureFlags('emails')?.active);
	const showUnlayerEmails = Boolean(getFeatureFlags('unlayerEmails')?.active);

	const showLegacyEmailActions = showEmail && !showUnlayerEmails;

	const openCreateDialog = useCallback((dialog) => dispatch(openDialog(dialog)), [dispatch]);

	const menuItems = useMemo(
		() => [
			{
				text: 'Create Task',
				icon: <Add />,
				onClick: () => openCreateDialog('task'),
			},
			{
				text: 'Create Note',
				icon: <Add />,
				onClick: () => openCreateDialog('note'),
			},
			...(showLegacyEmailActions
				? [
						{
							text: 'Create Email',
							icon: <Add />,
							onClick: () => openCreateDialog('email'),
						},
					]
				: []),
			...(showUnlayerEmails
				? [
						{
							text: 'Create Email',
							icon: <Add />,
							onClick: () => openCreateDialog('unlayerEmail'),
						},
					]
				: []),
		],
		[showLegacyEmailActions, showUnlayerEmails, openCreateDialog],
	);

	return {
		showEmail,
		showUnlayerEmails,
		showLegacyEmailActions,
		openCreateDialog,
		menuItems,
	};
};

export const TopNavCreateActions = () => {
	const theme = useTheme();
	const { showLegacyEmailActions, showUnlayerEmails, openCreateDialog } =
		useTopNavCreateActions();

	// Dark mode: icon/text turn white, but the outlined border keeps its current colour.
	const darkModeTextSx = theme.palette.mode === 'dark' ? { color: '#fff' } : undefined;

	return (
		<>
			<Button
				variant='outlined'
				size='small'
				startIcon={<Add />}
				onClick={() => openCreateDialog('task')}
				sx={darkModeTextSx}
			>
				{'Create Task'}
			</Button>
			<Button
				variant='outlined'
				size='small'
				startIcon={<Add />}
				onClick={() => openCreateDialog('note')}
				sx={darkModeTextSx}
			>
				{'Create Note'}
			</Button>
			{showLegacyEmailActions && (
				<Button
					variant='outlined'
					size='small'
					startIcon={<Add />}
					onClick={() => openCreateDialog('email')}
					sx={darkModeTextSx}
				>
					{'Create Email'}
				</Button>
			)}
			{showUnlayerEmails && (
				<Button
					variant='outlined'
					size='small'
					startIcon={<Add />}
					onClick={() => openCreateDialog('unlayerEmail')}
					sx={darkModeTextSx}
				>
					{'Create Email'}
				</Button>
			)}
		</>
	);
};
